/**
 * Thin top-of-viewport progress bar (STEP 13) for background activity
 * that shouldn't block the current page — driven by a real counter of
 * in-flight requests (`core/api/http-client.ts` increments/decrements
 * it via the axios interceptors), not a fixed timeout.
 */
import type { JSX } from 'react';
import { LinearProgress, Box } from '@mui/material';
import { useLoadingStore } from '@core/api/request-tracker';

export function GlobalLoader(): JSX.Element | null {
  const activeRequests = useLoadingStore((state) => state.activeRequests);

  if (activeRequests === 0) return null;

  return (
    <Box position="fixed" top={0} left={0} right={0} zIndex={(theme) => theme.zIndex.appBar + 1}>
      <LinearProgress aria-label="Loading" />
    </Box>
  );
}
